import { Fragment, useState, useEffect } from "react";
import { newSubscribe, verifySubscribe } from "../api/subscriptionService";
import { SUBSCRIPTION_PRICE } from "../constants";

const PRICE_ID = process.env.REACT_APP_PRICE_ID || "1";
const GAMING_URL = "https://shilail.com";

export default function SubscribeForm() {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [requestId, setRequestId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [alreadySubscribed, setAlreadySubscribed] = useState(false);
  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    if (step !== 3) return;
    setCountdown(3);
    const interval = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(interval);
          window.location.href = `${GAMING_URL}?msisdn=249${phone}`;
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [step]);

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{9}$/.test(phone)) {
      setError("أدخل رقم هاتف صحيح مكوّن من 9 أرقام");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await newSubscribe(`249${phone}`);
      if (res.data.data.subscribed) {
        setAlreadySubscribed(true);
        setStep(3);
      } else {
        setRequestId(res.data.data.subscribeRequestId);
        setStep(2);
      }
    } catch {
      setError("حدث خطأ، حاول مرة أخرى");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{4}$/.test(otp)) {
      setError("أدخل الرمز المكوّن من 4 أرقام");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await verifySubscribe(requestId, otp);

      setStep(3);
    } catch {
      setError("الرمز غلط، حاول مرة أخرى");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hero-sub-form">
      <div className="sub-steps">
        {[1, 2, 3].map((n, i) => (
          <Fragment key={n}>
            <span
              className={`sub-step-dot${step === n ? " s-active" : step > n ? " s-done" : ""}`}
            >
              {step > n ? "✓" : n}
            </span>
            {i < 2 && <span className="sub-step-line" />}
          </Fragment>
        ))}
      </div>

      {step === 1 && (
        <form onSubmit={handlePhoneSubmit} className="sub-form">
          <div className="sub-price-badge">
            <span className="sub-price-amount">{SUBSCRIPTION_PRICE}</span>
            <span className="sub-price-label"> جنيه / اليوم </span>
            <span className="sub-price-label"> يجدد تلقائياً </span>
          </div>
          <p className="sub-desc">أدخل رقم هاتفك لتلقي رمز التفعيل</p>
          <div className="phone-field">
            <span className="phone-prefix">+249</span>
            <input
              type="tel"
              className="phone-input"
              value={phone}
              onChange={(e) =>
                setPhone(e.target.value.replace(/\D/g, "").slice(0, 9))
              }
              placeholder="9XXXXXXXX"
              maxLength={9}
            />
          </div>
          {error && <p className="sub-error">{error}</p>}
          <button type="submit" className="btn-p sub-btn" disabled={loading}>
            {loading ? "جاري الإرسال..." : "🎮 ابدأ اللعب الآن"}
          </button>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={handleOtpSubmit} className="sub-form">
          <p className="sub-desc">
            تم إرسال رمز مكوّن من 4 أرقام إلى
            <br />
            <span dir="ltr">+249{phone}</span>
          </p>
          <input
            type="tel"
            className="otp-input"
            value={otp}
            onChange={(e) =>
              setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))
            }
            placeholder="- - - -"
            maxLength={4}
            autoFocus
          />
          {error && <p className="sub-error">{error}</p>}
          <button type="submit" className="btn-p sub-btn" disabled={loading}>
            {loading ? "جاري التحقق..." : "تأكيد الاشتراك"}
          </button>
          <button
            type="button"
            className="sub-back"
            onClick={() => {
              setStep(1);
              setOtp("");
              setError("");
            }}
          >
            تغيير رقم الهاتف
          </button>
        </form>
      )}

      {step === 3 && (
        <div className="sub-success">
          <div className="sub-check">✓</div>
          {alreadySubscribed ? (
            <>
              <h2>أنت مشترك بالفعل!</h2>
              <p>
                لديك اشتراك نشط في شليل للألعاب — أكثر من 100 لعبة بانتظارك!
              </p>
            </>
          ) : (
            <>
              <h2>تم الاشتراك بنجاح!</h2>
              <p>مرحباً بك في شليل للألعاب — أكتر من 100 لعبة بانتظارك!</p>
            </>
          )}
          <p className="sub-redirect-hint">
            سيتم توجيهك تلقائياً خلال {countdown} ثوانٍ...
          </p>
          <a
            href={`${GAMING_URL}?msisdn=249${phone}`}
            className="btn-p sub-btn"
          >
            🎮 ابدأ اللعب الآن
          </a>
        </div>
      )}
    </div>
  );
}
